import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import reportWebVitals from './reportWebVitals';
import Router from './route/Routing';
import { Provider } from 'react-redux';
import store from './store/store';
import "leaflet/dist/leaflet.css";
import { installFetchInterceptor } from './utils/fetchInterceptor';

// Install global fetch interceptor for timeout/gateway error handling
installFetchInterceptor();
// import { PublicClientApplication } from '@azure/msal-browser';
// import { MsalProvider } from '@azure/msal-react';
// import { msalConfig } from './authConfig';

// const msalInstance = new PublicClientApplication(msalConfig);

const originalWarn = console.warn;
console.warn = function(...args) {
  const message = args[0];
  if (typeof message === 'string' && (
    message.includes('findDOMNode is deprecated') ||
    message.includes('overlay` is deprecated')
  )) {
    return;
  }
  originalWarn.apply(console, args);
};

const renderApp = () => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    // <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <Router />
      </Provider>
    // </MsalProvider>
  );
};

renderApp();

// msalInstance.initialize().then(() => {
//   return msalInstance.handleRedirectPromise();
// }).then((response) => {
//   if (response) {
//     localStorage.setItem('adRedirectResponse', JSON.stringify({
//       email: response.account.username,
//       name: response.account.name,
//       idToken: response.idToken,
//     }));
//   }
//   renderApp();
// }).catch(() => {
//   renderApp();
// });

reportWebVitals();
